import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Badge } from 'primereact/badge';
import { Image } from 'primereact/image';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';

//Services
import { getAllDetails, postAllData } from '../../../service/ProductService';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

import { DOCUMENTLIST, FILEDETAIL, APPROVEOTHERAPP, UPLOADDOCUMENT, VERIFYDOCUMENT, APPROVEGOODSTANDINGPP, ELECTIONAPPLICATION } from '../../../config/ApiConstant';
import { formatDateTime, setOtherAppStatus } from '../../../appconfig/AppHelper';
import { ViewOtherDocumentColumns } from '../../../appconfig/DatatableSetting';
import { defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import OtherAppStatusChangeModal from '../../../components/Modal/OtherAppStatusChangeModal';
import { InputTextarea } from 'primereact/inputtextarea';
import { electionDepositRejectValidate } from '../../../config/Validate';
import Loader from '../../../components/Loadeer/Loader';

export const ViewOtherDocument = () => {
    document.title = 'View Document | GSPC';

    // Parameters
    const { fileno, appName, rno, status }: any = useParams();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    // File Upload Details
    const fileUploadRef = useRef(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [fileDetails, setFileDetails] = useState<any>([]);
    const [applicationStatus, setApplicationStatus] = useState<any>(null);
    const [documentsList, setDocumentsList] = useState<any>([]);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [changeStatusModal, setChangeStatusModal] = useState<boolean>(false);
    const [submitAppModal, setSubmitAppModal] = useState<boolean>(false);
    const [submitAppLoader, setSubmitAppLoader] = useState<boolean>(false);
    const [electionRejectModal, setElectionRejectModal] = useState<boolean>(false);
    const [electionRejectLoader, setElectionRejectLoader] = useState<boolean>(false);
    const [rejectReason, setRejectReason] = useState<any>('');
    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        getFileDetails();
        getAllDocument();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get file details
    const getFileDetails = async () => {
        setLoading(true);

        try {
            const response = await getAllDetails(FILEDETAIL + '?fileNo=' + atob(fileno) + '&AppName=' + atob(appName) + '&RNo=' + atob(rno));
            if (response) {
                setFileDetails(response);
                // Application Status
                let applicationBadgeInfo = setOtherAppStatus(atob(status));
                setApplicationStatus(applicationBadgeInfo);
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Get all documents
    const getAllDocument = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(DOCUMENTLIST + '?fileNo=' + atob(fileno) + '&AppName=' + atob(appName) + '&parent_id=' + atob(rno));
            if (response) {
                setDocumentsList(response?.documents);
                setPageLoad(true);
            }
        } catch (error: any) {
            if (error.response) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Template for view
    const viewTemplate = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-eye" onClick={() => window.open(rowData?.image_url)} disabled={!window.cn(rowData?.image_url) ? false : true} />
            </>
        );
    };

    // Template for document name
    const docNameTemplate = (rowData: any) => {
        return (
            <>
                <Button tooltip={rowData?.DocName} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">
                        {' '}
                        {rowData?.DocName} {rowData?.is_required === true && <span style={{ color: 'red' }}>*</span>}
                    </div>
                </Button>
            </>
        );
    };

    // Template for upload
    const uploadTemplate = (rowData: any) => {
        return (
            <>
                <FileUpload ref={fileUploadRef} accept="application/pdf" disabled={applicationStatus?.value === "Approved"} name="file[]" mode="basic" onSelect={(e) => onFileUpload(e, rowData)}></FileUpload>
            </>
        );
    };

    // On file upload
    const onFileUpload = async (e: any, rowData: any) => {
        let fileSize = e.files[0].size / 1024 / 1024;
        if (fileSize > 2) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please upload file size less than 2mb'
            });
        } else {
            setSubmitLoading(true);

            //Request object
            let formData: any = new FormData();
            formData.append('file', e.files[0]);
            formData.append('document_id', rowData.docId);
            formData.append('fileNo', atob(fileno));
            formData.append('parent_id', atob(rno));
            formData.append('applicationTypeName', atob(appName));

            //apicall
            const response = await postAllData(UPLOADDOCUMENT, formData);
            if (response && !window.cn(response)) {
                setSubmitLoading(false);

                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setTimeout(() => {
                    getAllDocument();
                }, 1500);
            }
        }
    };

    // On verify document
    const onVerifyDocument = async (verified: any, userDocId: any) => {
        let isVerified = verified === true ? 1 : 0;
        setSubmitLoading(true);

        const response = await getAllDetails(VERIFYDOCUMENT + '?fileNo=' + atob(fileno) + '&userDocId=' + userDocId + '&isVerified=' + isVerified);
        if (response) {
            setSubmitLoading(false);
            toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document Status Changed' });
            setTimeout(() => {
                getAllDocument();
            }, 1500);
        }
    };

    // Template for verification
    const verificationTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <InputSwitch checked={rowData?.isVerified == '1' ? true : false} onChange={(e) => onVerifyDocument(e.value, rowData?.userDocId)} disabled={!window.cn(rowData?.image_url) && applicationStatus?.value !== 'Approved' ? false : true} />
            </>
        );
    };

    // Template for uploaded by
    const uploadedByTemplate = (rowData: any, rowIndex: any) => {
        return <>{!window.cn(rowData.image_url) ? rowData.uploaded_status && rowData.uploaded_status == 1 ? <Badge severity="success" value="System"></Badge> : <Badge severity="warning" value="User"></Badge> : ''}</>;
    };

    // Open submit app modal
    const openSubmitAppModal = () => {
        setSubmitAppModal(true);
    };

    // Close submit app modal
    const closeSubmitAppModal = () => {
        setSubmitAppLoader(false);
        setSubmitAppModal(false);
    };

    // On submit application
    const onSubmitApplication = async () => {
        try {
            setSubmitAppLoader(true);
            let response: any;
            let formData: any = new FormData();
            const verifiedBy: any = localStorage.getItem('name');

            if (atob(appName) === 'Duplicate Certificate') {
                formData.append('RNo', atob(rno));

                formData.append('AppName', atob(appName));

                formData.append('verified_by', verifiedBy);

                formData.append('SrNo', atob(fileno));

                response = await postAllData(APPROVEGOODSTANDINGPP, formData);
            } else if (atob(appName) === 'Election Deposit') {
                formData.append('RNo', atob(rno));
                formData.append('status', 1);
                formData.append('verified_by', verifiedBy);
                formData.append('comment', '');
                response = await postAllData(ELECTIONAPPLICATION, formData);
            } else {
                response = await getAllDetails(APPROVEOTHERAPP + '?id=' + atob(rno) + '&AppName=' + atob(appName) + '&verified_by=' + verifiedBy);
            }

            if (response) {
                setSubmitAppLoader(false);
                setSubmitAppModal(false);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Message',
                    detail: response?.message
                });
                if (atob(appName) === 'Registration Renew') {
                    setTimeout(() => {
                        navigate('/app/application/renew-application');
                    }, 1500);
                } else if (atob(appName) === 'Re Entry') {
                    setTimeout(() => {
                        navigate('/app/application/re-entry');
                    }, 1500);
                } else if (atob(appName) == 'Name Change') {
                    setTimeout(() => {
                        navigate('/app/application/name-change');
                    }, 1500);
                } else if (atob(appName) == 'Duplicate Certificate') {
                    setTimeout(() => {
                        navigate('/app/application/duplicate-certificate-application-list');
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                setSubmitAppLoader(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Open change status modal
    const openChangeStatusModal = () => {
        if (atob(appName) === 'Election Deposit') {
            setElectionRejectModal(true);
        } else {
            setChangeStatusModal(true);
        }
    };

    // Close change status modal
    const closeChangeStatusModal = () => {
        setChangeStatusModal(false);
        setElectionRejectModal(false);
        setElectionRejectLoader(false);
        setRejectReason('');
        setErrors({});
    };

    // Reject election deposit
    const rejectElectionDepositApplication = async () => {
        try {
            const { errors, isError } = electionDepositRejectValidate(rejectReason);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setElectionRejectLoader(true);

                //Request object
                let formData: any = new FormData();
                formData.append('RNo', atob(rno));
                formData.append('status', 2);
                formData.append('comment', rejectReason);
                formData.append('verified_by', localStorage.getItem('name'));

                //apicall
                const response = await postAllData(ELECTIONAPPLICATION, formData);
                if (response && !window.cn(response)) {
                    setElectionRejectLoader(false);
                    setElectionRejectModal(false);
                    setRejectReason('');
                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        navigate('/app/application/election-deposit');
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setElectionRejectLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Applications'} pageName={'View Document'} pageTitle={'View Document'} goToPage={true} />

            <div className="card">
                <div className="p-fluid formgrid grid">
                    {atob(appName) === 'Registration Renew' && !window.cn(fileDetails?.Image) && (
                        <div className="mr-3">{!window.cn(fileDetails?.Image) && <Image src={fileDetails?.Image} style={{ border: '1px solid black' }} alt="Image" width="100" preview />}</div>
                    )}
                    <div className={atob(appName) === 'Registration Renew' && !window.cn(fileDetails?.Image) ? 'field col-12 md:col-5 grid flex-column mb-0' : 'field col-12 md:col-6 grid flex-column mb-0'}>
                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Full Name</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-9 mb-0">
                                {!window.cn(fileDetails?.StudL) && fileDetails?.StudL} {!window.cn(fileDetails?.StudF) && fileDetails?.StudF} {!window.cn(fileDetails?.StudM) && fileDetails?.StudM}
                            </div>
                        </div>

                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>File No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{fileDetails?.SrNo}</div>
                        </div>

                        <div className="field col-12 grid mb-0">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Status</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{!window.cn(applicationStatus?.severity) && <Badge severity={applicationStatus?.severity} value={applicationStatus?.value}></Badge>}</div>
                        </div>

                        {!window.cn(applicationStatus) && applicationStatus?.value === 'Documents : Reuploaded' && (
                            <div className="field col-12 grid mb-0 mt-3">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>Re-Uploaded Documents</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-9 mb-0">{fileDetails?.unverified_doclist}</div>
                            </div>
                        )}

                        {applicationStatus?.value === 'Hold' && (
                            <div className="field col-12 grid mb-0 mt-3">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>Reason</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-9 mb-0">{!window.cn(fileDetails?.comment) ? fileDetails?.comment : '-'}</div>
                            </div>
                        )}
                    </div>
                    <div className="field col-12 md:col-6 grid flex-column align-items-end mb-0">
                        <div className="field col-12 grid mb-3 justify-content-end">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>Application Date</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0 grid justify-content-end">{formatDateTime(fileDetails?.EntDt)}</div>
                        </div>

                        <div className="field col-12 grid mb-3 justify-content-end">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>Reg No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0 grid justify-content-end">{fileDetails?.RegNo}</div>
                        </div>

                        <div className="field col-12 grid mb-0  justify-content-end">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>Mobile No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0 grid justify-content-end">{fileDetails?.PPhone}</div>
                        </div>
                    </div>
                </div>

                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable value={documentsList} loading={submitLoading} showGridlines stripedRows rows={defaultRowOptions} className="datatable-responsive mt-3" emptyMessage="No Documents Found">
                            {ViewOtherDocumentColumns.map((col, i) => {
                                if (col.field === 'view') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={viewTemplate} />;
                                } else if (col.field === 'doc_name') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={docNameTemplate} style={{ maxWidth: '16rem' }} />;
                                } else if (col.field === 'upload') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={uploadTemplate} />;
                                } else if (col.field === 'verification') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={verificationTemplate} />;
                                } else if (col.field === 'uploaded_status') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={uploadedByTemplate} />;
                                } else if (col.field === 'sr_no') {
                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '2rem' }} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                }
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems} className="mt-3">
                            {ViewOtherDocumentColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}

                <div className="formgrid grid mt-3">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button
                                className="p-button-secondary mr-2"
                                icon="fas fa-edit"
                                label={atob(appName) === 'Election Deposit' ? 'Reject' : 'Change Status'}
                                onClick={openChangeStatusModal}
                                disabled={applicationStatus?.value === 'Approved' ? true : false}
                            />
                            <Button icon="pi pi-check" label={atob(appName) === 'Election Deposit' ? 'Approve' : 'Submit'} onClick={() => openSubmitAppModal()} loading={false} disabled={applicationStatus?.value === 'Approved' ? true : false} />
                        </div>
                    </div>
                </div>

                {/* Change Status Modal */}
                <OtherAppStatusChangeModal id={atob(rno)} appName={atob(appName)} visible={changeStatusModal} close={() => closeChangeStatusModal()} applicationName={atob(appName)} docList={documentsList} />

                {/* Election Deposit Reject Dialog */}
                <Dialog
                    visible={electionRejectModal}
                    className="p-fluid"
                    style={{ width: '100vh' }}
                    header={'Reject Application'}
                    modal
                    draggable={false}
                    resizable={false}
                    footer={
                        <>
                            <Button label="Cancel" className="p-button-secondary" onClick={closeChangeStatusModal} />
                            <Button label="Submit" className="p-button-primary" onClick={() => rejectElectionDepositApplication()} loading={electionRejectLoader} />
                        </>
                    }
                    onHide={closeChangeStatusModal}
                >
                    <div className="p-fluid formgrid grid">
                        <div className="col-12 md:col-12">
                            <label htmlFor="reason">
                                Reason <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <InputTextarea rows={5} cols={30} value={rejectReason} autoComplete="off" id="reason" onChange={(e) => setRejectReason(e.target.value)} className={errors['reason'] && 'p-invalid'} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                </Dialog>

                {/* Submit Application Dialog */}
                <Dialog
                    visible={submitAppModal}
                    className="p-fluid"
                    style={{ width: '100vh' }}
                    header={'Approve Application'}
                    modal
                    draggable={false}
                    resizable={false}
                    footer={
                        <>
                            <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeSubmitAppModal} />
                            <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitApplication()} loading={submitAppLoader} />
                        </>
                    }
                    onHide={closeSubmitAppModal}
                >
                    <h5>{atob(appName) === 'Election Deposit' ? 'Are you sure you want to submit this Application?' : 'Can You Submit This Application?'}</h5>
                </Dialog>
            </div>

            {loading && <Loader />}
        </>
    );
};
